export const THEME_KEY = 'dark';

export const getTheme = () => {
  return window.localStorage.getItem(THEME_KEY) === 'true';
};
